/**
 * @file css class names for font
 */

import { getHyphenatedCurrentLocale } from '@@/bits/current_locale'
import { __ } from '@@/bits/intl'

enum FontNameToFontId {
  Inter = 1,
  Lora = 2,
  ComicNeueAngular = 3,
  AverageMono = 4,
  ShantellSans = 5,
  CourierPrime = 6,
}

const LOCALE_FONT_OVERRIDE_LOCALES = ['zh-CN', 'zh', 'zh-TW', 'ar', 'fa', 'bg', 'ru', 'sr', 'vi', 'bn']

function hasLocaleFontOverride(): boolean {
  const locale = getHyphenatedCurrentLocale()
  return LOCALE_FONT_OVERRIDE_LOCALES.some((l) => locale === l)
}

function tailwindSurfaceFontClass(fontId: FontNameToFontId): string {
  let base: string
  switch (fontId) {
    case FontNameToFontId.Inter:
      base = 'font-sans'
      break
    case FontNameToFontId.Lora:
      base = 'font-serif'
      break
    case FontNameToFontId.ComicNeueAngular:
      base = 'font-cursive'
      break
    case FontNameToFontId.AverageMono:
      base = 'font-padlet-monospace'
      break
    case FontNameToFontId.ShantellSans:
      base = 'font-shantell'
      break
    case FontNameToFontId.CourierPrime:
      base = 'font-courier'
      break
    default:
      base = 'font-sans'
  }
  return hasLocaleFontOverride() ? `${base} surface-locale-font` : base
}

const whiteboardThemeFontOptions = {
  [FontNameToFontId.Inter]: __('Modern'),
  [FontNameToFontId.Lora]: __('Classic'),
  [FontNameToFontId.CourierPrime]: __('Technical'),
  [FontNameToFontId.ShantellSans]: __('Playful'),
}

export { FontNameToFontId, tailwindSurfaceFontClass, whiteboardThemeFontOptions }
